/**
 * Works for: /policy/:tenantId and /:tenantId
 */
export const getInitialTenantId = (): string | null => {
  const parts = window.location.pathname.split('/').filter(Boolean);
  if (!parts.length) return null;
  if (parts[0] === 'policy') return parts[1] ?? null;
  if (['login', 'auth', 'questionnaire'].includes(parts[0])) return null;
  return parts[0];
};
